/**
 * @author xiaohuangmao
 * @description 查看经销商
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { Descriptions } from 'antd';
import moment from 'moment'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import columns from "./columns";
const { WizContainer, modelUtils } = framework_tool;
const { WizCard, WizSpin, WizDataTable } = component_tool;
const { Session, getPageData } = utils_tool

class DealerInfoDetail extends WizContainer {

  componentName = 'DealerInfoDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let dealerInfoDetail = {};
    if (history.location && history.location.pathname === '/org/dealer/dealerInfoDetail') {
      if (history.location && history.location.record) {
        dealerInfoDetail = history.location.record;
        Session.set('dealerInfoDetail', dealerInfoDetail)
      } else {
        dealerInfoDetail = Session.get('dealerInfoDetail') || {};
      }
    }
    this.dealerInfoDetail = dealerInfoDetail;
  }

  _componentDidMount() {
    this._getData()
  }

  _getData = (other = {}) => {
    this.doActions([
      {
        path: 'dealer/look',
        payload: {
          key: 'lookKey',
          apiParams: { id: this.dealerInfoDetail.id, ...other }
        },
        requireLoading: true
      }
    ])
  }

  _getType = type => {
    let _type = ''
    switch (type) {
      case 0:
        _type = '无'
        break;
      case 1:
        _type = '4S网点'
        break;
      case 2:
        _type = '直营店'
        break;
      case 3:
        _type = '单一售后'
        break;
      case 4:
        _type = '单一销售'
        break;
      case 5:
        _type = '卫星店/直营店'
        break;
      case 6:
        _type = '自修站'
        break;
      case 7:
        _type = '卫星店'
        break;
      case 8:
        _type = '精品店'
        break;
      case 9:
        _type = 'dealer'
        break;
      case 10:
        _type = '4S店'
        break;
      case 11:
        _type = '汽车零售'
        break;
      case 12:
        _type = '单一销售展厅'
        break;
      case 13:
        _type = 'NEV单一售后'
        break;
      case 14:
        _type = '轻量化4S网点'
        break;
      case 15:
        _type = 'NEV专区'
        break;
      case 16:
        _type = '商超店'
        break;
      case 17:
        _type = '自修店'
        break;
      case 18:
        _type = '二级网点'
        break;
      case 19:
        _type = '车工坊C1'
        break;
      case 20:
        _type = '车工坊C2'
        break;
      case 21:
        _type = '车工坊B'
        break;
      case 22:
        _type = '德科品牌授权经销商'
        break;
      case 99:
        _type = '暂定'
        break;
    }
    return _type
  }

  _getState = state => {
    let _state = ''
    switch (state) {
      case 0:
        _state = '已关店'
        break;
      case 1:
        _state = '已开店'
        break;
      case 2:
        _state = '建设中'
        break;
    }
    return _state
  }

  _render() {
    const { list, dealerLoading } = this.props
    const items = this.dealerInfoDetail;
    const dataItems = getPageData({ records: list.data })
    const dataTableProps = {
      columns,
      rowKey: 'id',
      dataItems
    }

    return (
      <React.Fragment>
        <WizCard title="经销商信息">
          <Descriptions column={2} style={{ paddingLeft: 25 }}>
            <Descriptions.Item label='经销商名称'>{items.name}</Descriptions.Item>
            <Descriptions.Item label='经销商简称'>{items.shortName}</Descriptions.Item>
            <Descriptions.Item label='销售代码'>{items.preSalesNumber}</Descriptions.Item>
            <Descriptions.Item label='售后代码'>{items.afterSalesNumber}</Descriptions.Item>
            <Descriptions.Item label='上级组织' span={2}>{items.brandName}/{items.areaName}</Descriptions.Item>
            <Descriptions.Item label='站点类型'>{this._getType(items.type)}</Descriptions.Item>
            <Descriptions.Item label='单一销售展厅类型区分'>{items.nevTypeStr}</Descriptions.Item>
            <Descriptions.Item label='ASC编码'>{items.state}</Descriptions.Item>
            <Descriptions.Item label='开店状态'>{this._getState(items.state)}</Descriptions.Item>
            <Descriptions.Item label='开店时间'>{moment(items.openTime).format('YYYY-MM-DD')}</Descriptions.Item>
            <Descriptions.Item label='省份'>{items.province}</Descriptions.Item>
            <Descriptions.Item label='城市'>{items.city}</Descriptions.Item>
            <Descriptions.Item label='地址' span={2}>{items.region} {items.address}</Descriptions.Item>
            <Descriptions.Item label='所属集团' span={2}>{items.bloc}</Descriptions.Item>
            <Descriptions.Item label='备注' span={2}>{items.remark}</Descriptions.Item>
          </Descriptions>
        </WizCard>

        <WizCard title="共建经销商">
          <WizSpin tip={"加载中"} spinning={dealerLoading}>
            <WizDataTable {...dataTableProps} />
          </WizSpin>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { dealer } = state;
  const list = modelUtils.getModelEntity(dealer, "lookKey");
  const load = modelUtils.getLoadingState(state, "dealer");
  return {
    list,
    ...load
  };
};

export default connect(mapStateToProps)(DealerInfoDetail);
